// extracted by mini-css-extract-plugin
export default {"content":"cKF3E1_lj1hq9AIkkB5w","footer-list":"r6J1jLRRfVFMDMzFx8nQ"};